import { Button } from '@mui/material'
import { logout } from '@utils/sessions'

const LogoutButton = () => (
    <Button variant="outlined" onClick={logout}>
        Logout
    </Button>
)

export default LogoutButton
